export { CarouselProductImage } from "./carousel-product-image.component";